import { useState } from 'react';

export default function MasterclassTopics() {
  const [activeTab, setActiveTab] = useState(0);

  const topics = [
    {
      id: 0,
      title: 'Dubai früher',
      icon: 'ri-history-line',
      color: 'blue',
      content: {
        subtitle: 'Vom Wüstenhandel zur Weltmetropole',
        description: 'Eine faszinierende Zeitreise durch die Transformation Dubais:',
        points: [
          'Wie Dubai vor wenigen Jahrzehnten aussah',
          'Die Transformation durch Öl, Handel, Hafen, Infrastruktur',
          'Die Vision von Sheikh Mohammed – und warum sie funktionierte',
          'Warum Dubai heute das erfolgreichste Stadtentwicklungsmodell der Welt ist',
          'Der Weg von Sandwüste → Megacity → globaler Business-Hub'
        ]
      }
    },
    {
      id: 1,
      title: 'Dubai heute',
      icon: 'ri-building-4-line',
      color: 'yellow',
      content: {
        subtitle: 'Das Ökosystem für internationale Investoren',
        description: 'Aktuelle Einblicke in das heutige Dubai:',
        points: [
          'Wirtschaftliche Kennzahlen und Wachstumsraten',
          'Migration, Demografie, Arbeitsmarkt-Struktur',
          'Steuerliches Umfeld & Null-Prozent-Einkommensteuer',
          'Politische Stabilität & Rechtsstaatlichkeit',
          'Warum Dubai heute für Unternehmer, Investoren und Expats die No. 1 ist',
          'Infrastruktur: Flughäfen, Häfen, Freezones, Logistik, Lifestyle'
        ]
      }
    },
    {
      id: 2,
      title: 'Immobilienmarkt',
      icon: 'ri-home-4-line',
      color: 'green',
      content: {
        subtitle: 'Off-Plan vs. Ready Properties',
        description: 'Ein kompletter Deep Dive in den Immobilienmarkt der Emirate:',
        sections: [
          {
            title: 'Off-Plan (Bau in Vorbereitung)',
            advantages: [
              'Einstiegspreise deutlich niedriger',
              'Payment Plans (0–80%, 1–2 Jahre Post-Handover)',
              'Hohe Kapitalrendite durch Wertsteigerung',
              'Zugang zu Top-Projekten in Frühphasen',
              'Ideal für skalierende Investoren'
            ],
            risks: [
              'Entwicklerqualität',
              'Verzögerungen',
              'Überbewertungen & künstliche Nachfrage',
              'Vertragsfallen (SPA, DLD, Oqood etc.)'
            ]
          },
          {
            title: 'Ready (Bestandsimmobilien)',
            advantages: [
              'Sofortige Vermietung möglich',
              'Keine Bauphase-Risiken',
              'Realistische Bewertung',
              'Perfekt für Eigenbedarf'
            ],
            risks: [
              'Höhere Einstiegspreise',
              'Weniger extreme Renditen',
              'Renovierungsaufwand'
            ]
          }
        ],
        footer: 'Wir vergleichen echte Projekte, echte Zahlen, echte Beispiele.'
      }
    },
    {
      id: 3,
      title: 'Firmen & Freezones',
      icon: 'ri-briefcase-line',
      color: 'purple',
      content: {
        subtitle: 'Banken, Firmengründungen & Freezones',
        description: 'Detaillierte Erklärungen zu allen wichtigen Aspekten:',
        sections: [
          {
            title: 'Firmengründung',
            points: [
              'Mainland (LLC) vs Freezone',
              '100 % Eigentum für Ausländer',
              'Sponsorship-Regelungen früher & heute',
              'Kosten, Lizenzen, jährliche Gebühren',
              'Welche Struktur passt zu welchem Geschäftsmodell?'
            ]
          },
          {
            title: 'Bankkontoeröffnung',
            points: [
              'Private Accounts',
              'Corporate Accounts',
              'Compliance, KYC, Source of Funds',
              'Typische Fehler und wie man sie vermeidet'
            ]
          },
          {
            title: 'Freezones der Emirate',
            description: 'Überblick über alle sieben Emirate und ihre bekanntesten Freezones:',
            emirates: [
              { name: 'Dubai', zones: 'IFZA, DMCC, Meydan, DIFC, TECOM, DAFZA, Dubai South' },
              { name: 'Abu Dhabi', zones: 'ADGM, Abu Dhabi Freezone' },
              { name: 'Sharjah', zones: 'Shams, SAIF Zone' },
              { name: 'Ajman, Umm Al Quwain, Ras Al Khaimah, Fujairah', zones: 'Verschiedene Freezones' }
            ],
            questions: [
              'Welche Freezone ist wofür?',
              'Wer sollte wo gründen?',
              'Wo gibt es Banking?',
              'Wo gibt es keine?'
            ]
          }
        ]
      }
    },
    {
      id: 4,
      title: '7 Emirate & GCC',
      icon: 'ri-global-line',
      color: 'red',
      content: {
        subtitle: 'Die 7 Emirate & GCC-Länder',
        description: 'Ein klarer Überblick über die gesamte Region:',
        sections: [
          {
            title: 'Die 7 Emirate',
            emirates: [
              'Dubai',
              'Abu Dhabi',
              'Sharjah',
              'Ajman',
              'Umm Al Quwain',
              'Ras Al Khaimah',
              'Fujairah'
            ],
            note: 'Wirtschaft, Regeln, Immobilien, Steuern, Branchenfokus – alles erklärt.'
          },
          {
            title: 'GCC-Länder',
            countries: [
              {
                name: 'Saudi-Arabien',
                points: ['Vision 2030', 'Megaprojekte wie NEOM, The Line, Red Sea', 'Arbeitsmarkt-Revolution', 'Chancen & Risiken für Investoren']
              },
              {
                name: 'Katar',
                points: ['Post-WM Boom', 'Immobilien & Unternehmensstrukturen', 'Gaswirtschaft & stabile Einnahmen']
              },
              {
                name: 'Bahrain',
                points: ['Günstigste Firmengründung', 'Starke Finanzbranche']
              },
              {
                name: 'Oman',
                points: ['Kühlere Investitionsmöglichkeiten', 'Tourismusprojekte & Special Zones']
              },
              {
                name: 'Kuwait',
                points: ['Politisch besonders', 'Investment nur für Fortgeschrittene']
              }
            ]
          }
        ]
      }
    },
    {
      id: 5,
      title: 'Crypto & Compliance',
      icon: 'ri-coin-line',
      color: 'indigo',
      content: {
        subtitle: 'Crypto, Compliance & Regulierung',
        description: 'Klare Einblicke in die Krypto-Landschaft Dubais:',
        points: [
          'Wie Krypto in Dubai reguliert wird',
          'VARA-Lizenzen',
          'Banken & Krypto – was geht, was nicht',
          'Risikomanagement',
          'Internationale Vergleichbarkeit'
        ]
      }
    }
  ];

  const colorClasses: Record<string, { bg: string; text: string; border: string; active: string }> = {
    blue: { bg: 'bg-blue-50', text: 'text-blue-600', border: 'border-blue-200', active: 'bg-blue-500' },
    yellow: { bg: 'bg-yellow-50', text: 'text-yellow-600', border: 'border-yellow-200', active: 'bg-yellow-500' },
    green: { bg: 'bg-green-50', text: 'text-green-600', border: 'border-green-200', active: 'bg-green-500' },
    purple: { bg: 'bg-purple-50', text: 'text-purple-600', border: 'border-purple-200', active: 'bg-purple-500' },
    red: { bg: 'bg-red-50', text: 'text-red-600', border: 'border-red-200', active: 'bg-red-500' },
    indigo: { bg: 'bg-indigo-50', text: 'text-indigo-600', border: 'border-indigo-200', active: 'bg-indigo-500' }
  };

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-black mb-6">
            Die <span className="text-yellow-500">Masterclass-Themen</span> im Detail
          </h2>
          <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
            Sechs umfassende Module mit tiefem Insiderwissen und praktischen Beispielen
          </p>
        </div>

        <div className="flex flex-wrap gap-4 mb-12 justify-center">
          {topics.map((topic) => (
            <button
              key={topic.id}
              onClick={() => setActiveTab(topic.id)}
              className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 flex items-center whitespace-nowrap ${
                activeTab === topic.id
                  ? `${colorClasses[topic.color].active} text-white shadow-lg transform scale-105`
                  : 'bg-white text-gray-700 hover:shadow-md'
              }`}
            >
              <i className={`${topic.icon} text-xl mr-2`}></i>
              {topic.title}
            </button>
          ))}
        </div>

        <div className="bg-white rounded-3xl shadow-xl p-12">
          {topics.map((topic) => (
            <div
              key={topic.id}
              className={`${activeTab === topic.id ? 'block' : 'hidden'}`}
            >
              <div className="flex items-center mb-8">
                <div className={`w-16 h-16 ${colorClasses[topic.color].active} rounded-full flex items-center justify-center mr-6`}>
                  <i className={`${topic.icon} text-white text-3xl`}></i>
                </div>
                <div>
                  <h3 className="text-3xl font-bold text-gray-900">{topic.title}</h3>
                  <p className="text-xl text-gray-600 mt-2">{topic.content.subtitle}</p>
                </div>
              </div>

              <p className="text-lg text-gray-700 mb-6">{topic.content.description}</p>

              {topic.content.points && (
                <ul className="space-y-4">
                  {topic.content.points.map((point, index) => (
                    <li key={index} className="flex items-start">
                      <i className={`ri-arrow-right-s-line ${colorClasses[topic.color].text} text-2xl mr-3 mt-1`}></i>
                      <span className="text-lg text-gray-700">{point}</span>
                    </li>
                  ))}
                </ul>
              )}

              {topic.content.sections && (
                <div className="space-y-8 mt-8">
                  {topic.content.sections.map((section, index) => (
                    <div key={index} className={`${colorClasses[topic.color].bg} rounded-2xl p-8 border-2 ${colorClasses[topic.color].border}`}>
                      <h4 className="text-2xl font-bold text-gray-900 mb-4">{section.title}</h4>
                      
                      {section.points && (
                        <ul className="space-y-3">
                          {section.points.map((point, idx) => (
                            <li key={idx} className="flex items-start">
                              <i className={`ri-checkbox-circle-line ${colorClasses[topic.color].text} text-xl mr-3 mt-1`}></i>
                              <span className="text-gray-700">{point}</span>
                            </li>
                          ))}
                        </ul>
                      )}

                      {section.advantages && (
                        <div className="mb-6">
                          <h5 className="font-bold text-gray-900 mb-3 flex items-center">
                            <i className="ri-thumb-up-line text-green-500 mr-2"></i>
                            Vorteile:
                          </h5>
                          <ul className="space-y-2 ml-6">
                            {section.advantages.map((adv, idx) => (
                              <li key={idx} className="flex items-start">
                                <i className="ri-add-line text-green-500 mr-2 mt-1"></i>
                                <span className="text-gray-700">{adv}</span>
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}

                      {section.risks && (
                        <div>
                          <h5 className="font-bold text-gray-900 mb-3 flex items-center">
                            <i className="ri-alert-line text-red-500 mr-2"></i>
                            Risiken:
                          </h5>
                          <ul className="space-y-2 ml-6">
                            {section.risks.map((risk, idx) => (
                              <li key={idx} className="flex items-start">
                                <i className="ri-subtract-line text-red-500 mr-2 mt-1"></i>
                                <span className="text-gray-700">{risk}</span>
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}

                      {section.description && <p className="text-gray-700 mb-4">{section.description}</p>}

                      {section.emirates && (
                        <div className="space-y-3">
                          {section.emirates.map((emirate, idx) => (
                            <div key={idx} className="bg-white rounded-lg p-4">
                              <strong className="text-gray-900">{emirate.name}:</strong>
                              <span className="text-gray-700 ml-2">{emirate.zones}</span>
                            </div>
                          ))}
                        </div>
                      )}

                      {section.questions && (
                        <div className="mt-6 bg-white rounded-lg p-6">
                          <h5 className="font-bold text-gray-900 mb-3">Wichtige Fragen, die wir beantworten:</h5>
                          <ul className="space-y-2">
                            {section.questions.map((question, idx) => (
                              <li key={idx} className="flex items-start">
                                <i className="ri-question-line text-yellow-500 mr-2 mt-1"></i>
                                <span className="text-gray-700">{question}</span>
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}

                      {section.note && (
                        <p className="text-gray-600 italic mt-4">{section.note}</p>
                      )}

                      {section.countries && (
                        <div className="grid md:grid-cols-2 gap-6">
                          {section.countries.map((country, idx) => (
                            <div key={idx} className="bg-white rounded-lg p-6">
                              <h5 className="font-bold text-gray-900 mb-3">{country.name}</h5>
                              <ul className="space-y-2">
                                {country.points.map((point, pidx) => (
                                  <li key={pidx} className="flex items-start">
                                    <i className="ri-map-pin-line text-gray-500 mr-2 mt-1"></i>
                                    <span className="text-gray-700 text-sm">{point}</span>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}

              {topic.content.footer && (
                <div className="mt-8 bg-gradient-to-r from-yellow-50 to-yellow-100 rounded-xl p-6 border-2 border-yellow-200">
                  <p className="text-lg font-semibold text-gray-900 text-center">
                    <i className="ri-lightbulb-line text-yellow-500 mr-2"></i>
                    {topic.content.footer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
